<div class="banner-container">
   <div class="heading-text-style">Application Banner</div>
    <div style="margin-left: 20px; margin-bottom: 20px; ">
        <div class="dwform">
            <div class="dwform-row-gap"></div>
            <div class="dwform-row">
                <label class="label-field">Banner Text:</label>
                <label class="form-required"> </label>
                <input class="input-field" id="bannerStringId"
                       style="width:400px" type="text"
                       [(ngModel)]="valBannerText"
                       [disabled]="!editMode">

                <div class="dwform-row-gap"></div>
                <label class="label-field">Background Color:</label>
                <label class="form-required"> </label>
                <input style="width: 30px; vertical-align: middle;" type="color" id="backcolor" name="backcolor" [(ngModel)]="valBackColor" [disabled]="!editMode"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                <div class="dwform-row-gap"></div>
                <label class="label-field">Show Banner:</label>
                <label class="form-required"> </label>

                <mat-checkbox [(ngModel)]="valEnableBanner" binary="true" [disabled]="!editMode"></mat-checkbox>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row-gap"></div>
            </div>
        </div>
        <div *ngIf="editMode" style="width:100%;text-align:center">
            <button mat-button class="command-button" (click)="doSubmit()"
                    matTooltip="Submit data" mat-button [disabled]="!editMode">
                <mat-icon>check_circle_outline</mat-icon>
                Submit
            </button>
            <button mat-button class="command-button" (click)="doCancel()"
                    matTooltip="Cancel changes" mat-button [disabled]="!editMode">
                <mat-icon>highlight_off</mat-icon>
                Cancel
            </button>
        </div>

        <div *ngIf="!editMode && visibleModify" style="width:100%;text-align:center" >
            <button mat-button class="command-button" (click)="enterEditMode()"
                    matTooltip="Edit data" mat-button>
                <mat-icon>edit</mat-icon>
                Edit
            </button>
        </div>
    </div>
</div>
